// This file is generated by "yarn svgicons"
// Input directory: "/app/Styling/frontend/svgIcons/"
    
export const svgIconNames = ["chevron-down","chevron-left","chevron-right","chevron-up","leaf","lifebuoy","project-Icon_cutter suction dredger","project-Icon_driver Sustainable cities and communities","project-Icon_personnel","search","video-pause","video-play"] as const
    
export type SVGIconName = typeof svgIconNames[number]